var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOntime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 150 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5753 143.371C127.965 133.998 150 106.205 150 73.3766C150 56.3505 144.073 40.6788 134.127 28.2288L64.2141 67.9955V107.13L31.8563 89.7639V48.673L106.016 6.54893C96.5637 2.34281 86.0615 0 75 0C33.5786 0 0 32.8518 0 73.3766C0 110.318 27.903 140.884 64.2141 146V107.13L97.5753 86.8289V143.371Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntime);
export default __webpack_public_path__ + "static/media/ONTIME.09b34b13202b9aa4de6f3793cca5ef87.svg";
export { ForwardRef as ReactComponent };